import { FC, PropsWithChildren } from 'react';
import { InternalTemplates } from 'modules/predictiveGoals/types';

import { FullTemplateCard } from './FullTemplateCard';
import { TemplateSectionContainer } from './TemplateSection.styles';

export const PageTestIds = {
  TemplateSectionCards: 'templates-section-cards',
};

export interface TemplateSectionProps {
  children?: React.ReactNode;
  getIsTemplateEventDisabled: (templateType: InternalTemplates) => boolean;
  onTemplateSelection: (templateType: InternalTemplates) => void;
}
export const TemplateSection: FC<PropsWithChildren<TemplateSectionProps>> = ({
  getIsTemplateEventDisabled,
  onTemplateSelection,
}) => {
  return (
    <TemplateSectionContainer data-test={PageTestIds.TemplateSectionCards}>
      <FullTemplateCard
        isDisabled={getIsTemplateEventDisabled(InternalTemplates.ENGAGE)}
        onTemplateSelection={onTemplateSelection}
        templateType={InternalTemplates.ENGAGE}
      />
      <FullTemplateCard
        isDisabled={getIsTemplateEventDisabled(InternalTemplates.CHURN)}
        onTemplateSelection={onTemplateSelection}
        templateType={InternalTemplates.CHURN}
      />
      <FullTemplateCard
        isDisabled={getIsTemplateEventDisabled(InternalTemplates.PURCHASE)}
        onTemplateSelection={onTemplateSelection}
        templateType={InternalTemplates.PURCHASE}
      />
    </TemplateSectionContainer>
  );
};
